import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../context/index";
import { HashLink } from "react-router-hash-link";
import { LogoII } from "../../../assets";
import { navLinks } from "../../../config/navlinks/home";
import { NavbarWrapper, NavLinksWrapper, NavButtonsContainer } from "./styled";
import { BaseButton } from "../../../components/button/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Span } from "../../../components/typography/styled";

export const Navbar = () => {
  const navigate = useNavigate();
  const { isMenuOpen, setIsMenuOpen } = useContext(Context);

  const handleHamburgerClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (destination) => {
    navigate(destination);
  };

  return (
    <NavbarWrapper>
      <div className="logo-box-area">
        <LogoII />
      </div>
      <NavLinksWrapper>
        {navLinks.map((navLink, index) => {
          return (
            <HashLink key={index} to={navLink.url} smooth={true}>
              <Span>{navLink.name}</Span>
            </HashLink>
          );
        })}
        <div className="mobile-buttons">
          <BaseButton
            className="login-button"
            color={"var(--color-primary)"}
            backgroundcolor={"transparent"}
            width={"fit-content"}
            onClick={() => handleNavigation("/login")}
          >
            Login
          </BaseButton>
          <BaseButton
            backgroundcolor={"var(--color-primary)"}
            width={"fit-content"}
            onClick={() => handleNavigation("/how")}
          >
            Get Started
          </BaseButton>
        </div>
      </NavLinksWrapper>
      <NavButtonsContainer>
        <BaseButton
          className="login-button"
          color={"var(--color-primary)"}
          backgroundcolor={"transparent"}
          hovercolor={"var(--color-text)"}
          width={"fit-content"}
          onClick={() => handleNavigation("/login")}
        >
          Login
        </BaseButton>
        <BaseButton
          backgroundcolor={"var(--color-primary)"}
          width={"fit-content"}
          onClick={() => handleNavigation("/how")}
        >
          Get Started
        </BaseButton>
      </NavButtonsContainer>
      <div className="hamburger-icon" onClick={handleHamburgerClick}>
        {isMenuOpen ? (
          <FontAwesomeIcon icon={faXmark} />
        ) : (
          <FontAwesomeIcon icon={faBars} />
        )}
      </div>
    </NavbarWrapper>
  );
};
